export default __webpack_public_path__ + "static/media/logoLetters.480e3862.png";